import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useGroupCreateForm } from './hooks';

export const GroupCreateScreen = () => {
    const navigate = useNavigate();
    const { token } = useSelector((state) => state.auth);

    const {
        isLoadingUsers,
        isSaving,
        error,
        searchTerm,
        selectedUsers,
        filteredUsers,
        name,
        setSearchTerm,
        setName,
        handleAddUser,
        handleRemoveUser,
        handleSubmit,
        handleCancel,
    } = useGroupCreateForm({
        token,
        navigate,
    });

    return (
        <div className="row">
            <div className="col-12 col-xl-9 col-xxl-8 mx-auto">
                <div className="card card__no-border">
                    <div className="card-body">
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <h5 className="fw-bold mb-0">Nuevo grupo</h5>
                            <button type="button" className="btn btn-light-brand" onClick={handleCancel}>
                                Volver
                            </button>
                        </div>

                        {error && (
                            <div className="alert alert-danger py-2" role="alert">
                                {error}
                            </div>
                        )}

                        <form onSubmit={handleSubmit}>
                            <div className="row g-2">
                                <div className="col-12">
                                    <label className="form-label" htmlFor="group-name">Nombre del grupo</label>
                                    <input
                                        id="group-name"
                                        name="name"
                                        type="text"
                                        className="form-control"
                                        value={name}
                                        onChange={(event) => setName(event.target.value)}
                                        required
                                    />
                                </div>

                                <div className="col-12">
                                    <label className="form-label" htmlFor="group-user-search">Buscar usuarios para el grupo</label>
                                    <input
                                        id="group-user-search"
                                        type="search"
                                        className="form-control"
                                        placeholder="Escribe nombre, email o rol"
                                        value={searchTerm}
                                        onChange={(event) => setSearchTerm(event.target.value)}
                                        disabled={isLoadingUsers}
                                    />

                                    {searchTerm.trim().length > 0 && (
                                        <div className="border border-gray-3 rounded-2 mt-2">
                                            {filteredUsers.length === 0 && (
                                                <div className="p-2 text-muted">Sin resultados para esta búsqueda.</div>
                                            )}

                                            {filteredUsers.length > 0 && (
                                                <div className="list-group list-group-flush">
                                                    {filteredUsers.map((user) => (
                                                        <button
                                                            key={user._id}
                                                            type="button"
                                                            className="list-group-item list-group-item-action d-flex align-items-center justify-content-between"
                                                            onClick={() => handleAddUser(user._id)}
                                                        >
                                                            <span>{user?.name || '-'} ({user?.email || '-'})</span>
                                                            <span className="badge bg-soft-primary text-primary">Agregar</span>
                                                        </button>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>

                                <div className="col-12 mt-3">
                                    <h6 className="fw-semibold mb-2">Usuarios seleccionados</h6>

                                    {selectedUsers.length === 0 && (
                                        <div className="text-muted">No hay usuarios seleccionados.</div>
                                    )}

                                    {selectedUsers.length > 0 && (
                                        <div className="table-responsive border rounded-3">
                                            <table className="table table-bordered mb-0 align-middle">
                                                <thead>
                                                    <tr>
                                                        <th>Nombre</th>
                                                        <th>Email</th>
                                                        <th>Rol</th>
                                                        <th style={{ width: '90px' }}>Acción</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {selectedUsers.map((user) => (
                                                        <tr key={user._id}>
                                                            <td>{user?.name || '-'}</td>
                                                            <td>{user?.email || '-'}</td>
                                                            <td>{user?.role || '-'}</td>
                                                            <td>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-outline-danger btn-sm"
                                                                    onClick={() => handleRemoveUser(user._id)}
                                                                >
                                                                    Quitar
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="d-flex justify-content-end gap-2 mt-3">
                                <button
                                    type="button"
                                    className="btn btn-light-brand"
                                    onClick={handleCancel}
                                    disabled={isSaving}
                                >
                                    Cancelar
                                </button>
                                <button type="submit" className="btn btn-primary" disabled={isSaving || isLoadingUsers}>
                                    {isSaving ? 'Guardando...' : 'Crear grupo'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};
